"use client";

import { useId, type ReactNode } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export function AuthField(props: {
  label: string;
  value: string;
  onChange: (value: string) => void;
  autoComplete: string;
  type?: "text" | "email" | "password";
  hint?: string;
  labelAction?: ReactNode;
  autoFocus?: boolean;
  error?: string;
  onBlur?: () => void;
}) {
  const id = useId();
  const hintId = `${id}-hint`;
  const errorId = `${id}-error`;
  const describedBy = [props.hint ? hintId : null, props.error ? errorId : null]
    .filter(Boolean)
    .join(" ");
  return (
    <div className="space-y-1">
      <div className="flex items-baseline justify-between gap-2">
        <Label htmlFor={id}>{props.label}</Label>
        {props.labelAction}
      </div>
      <Input
        id={id}
        type={props.type ?? "text"}
        required
        autoFocus={props.autoFocus}
        autoComplete={props.autoComplete}
        aria-describedby={describedBy || undefined}
        aria-invalid={props.error ? true : undefined}
        value={props.value}
        onChange={(event) => props.onChange(event.target.value)}
        onBlur={props.onBlur}
      />
      {props.error ? (
        <p id={errorId} data-field-error className="text-xs text-destructive-strong">
          {props.error}
        </p>
      ) : null}
      {props.hint ? (
        <p id={hintId} className="text-xs text-muted-foreground">
          {props.hint}
        </p>
      ) : null}
    </div>
  );
}
